import '../styles/Testimonials.css';

const testimonials = [
  {
    initials: 'AK',
    color: 'teal',
    name: 'Ayşe Kılıç',
    biz: 'Butik Moda, İstanbul',
    text: '3 ayda Instagram takipçimiz 2.000\'den 18.000\'e çıktı. Reklam maliyetimiz düşerken satışlarımız 3 kat arttı. Gerçekten sonuç odaklı bir ekip.',
    rating: 5,
  },
  {
    initials: 'MO',
    color: 'gold',
    name: 'Mehmet Öztürk',
    biz: 'Restoran Zinciri, Ankara',
    text: 'TikTok kanalımızı sıfırdan kurdular. İlk viral videomuzu ikinci haftada çıkardık. Profesyonellik ve hız konusunda rakipsizler.',
    rating: 5,
  },
  {
    initials: 'SD',
    color: 'purple',
    name: 'Selin Demirci',
    biz: 'Yazılım Şirketi, İzmir',
    text: 'LinkedIn stratejimiz sayesinde B2B müşteri başvurularımız %240 arttı. Raporlar çok detaylı, her zaman ulaşılabilirler.',
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section className="testimonials" id="referanslar">
      <div className="testimonials__head">
        <span className="label">Referanslar</span>
        <h2 className="section-title">Müşterilerimiz<br />Ne Diyor?</h2>
      </div>

      <div className="testimonials__grid">
        {testimonials.map((t, i) => (
          <div key={i} className="testi-card">
            <div className="testi-card__stars">
              {'★'.repeat(t.rating)}
            </div>
            <p className="testi-card__text">"{t.text}"</p>
            <div className="testi-card__author">
              <div className={`testi-card__avatar testi-card__avatar--${t.color}`}>
                {t.initials}
              </div>
              <div>
                <div className="testi-card__name">{t.name}</div>
                <div className="testi-card__biz">{t.biz}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
